import React from "react";
import { ShieldCheck, UserCheck, CalendarClock, Languages, Gift, Phone } from "lucide-react";
import Seo from "../components/Seo";
import BookingForm from "../components/BookingForm";
import WhyUs from "../components/WhyUs";
import { contactInfo } from "../mock";
import { useLang } from "../context/LanguageContext";

const iconMap = { ShieldCheck, UserCheck, CalendarClock, Languages };

const Booking = () => {
  const { lang, t } = useLang();
  const seo = lang === "de"
    ? { title: "Putzfrau buchen – 1. Stunde gratis | MyCleaner.ch", description: "Buchen Sie Ihre persönliche Putzfrau in wenigen Minuten: Stunden und Wunschtag angeben, Aufgaben auswählen. Fixpreis 43.90 CHF/Std., ohne Kreditkarte, 1. Stunde gratis.", keywords: "Putzfrau buchen, Putzfrau anfragen, Haushaltshilfe buchen Schweiz, Putzhilfe buchen" }
    : { title: "Book a cleaner – 1st hour free | MyCleaner.ch", description: "Book your personal cleaner in minutes: choose hours and preferred day, pick tasks. Flat rate CHF 43.90/hr, no credit card, 1st hour free.", keywords: "book a cleaner, request a cleaner, home help booking Switzerland" };

  return (
    <div className="bg-amber-50/40 min-h-screen">
      <Seo pageKey="booking" title={seo.title} description={seo.description} keywords={seo.keywords} />

      <section className="pt-[116px] pb-10">
        <div className="max-w-[1100px] mx-auto px-5 md:px-6">
          <div className="text-center max-w-2xl mx-auto mb-10">
            <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 font-semibold text-sm px-4 py-1.5 rounded-full mb-4"><Gift className="w-4 h-4" /> {t.cta.badge}</div>
            <h1 className="font-head font-extrabold text-4xl md:text-5xl leading-tight text-slate-900 mb-4">{t.booking.title}</h1>
            <p className="text-lg text-slate-600">{t.bookingSection.desc}</p>
          </div>

          <div className="grid lg:grid-cols-5 gap-8 items-start">
            <div className="lg:col-span-3"><BookingForm /></div>
            <aside className="lg:col-span-2 space-y-4 lg:sticky lg:top-28">
              <div className="bg-white rounded-2xl border border-slate-100 p-6">
                <h2 className="font-head font-bold text-slate-900 text-lg mb-4">{t.trustEyebrow}</h2>
                <ul className="space-y-4">
                  {t.trustPoints.map((tp) => {
                    const Icon = iconMap[tp.icon];
                    return (
                      <li key={tp.title} className="flex items-start gap-3">
                        <span className="w-9 h-9 rounded-lg bg-teal-50 flex items-center justify-center shrink-0"><Icon className="w-4 h-4 text-teal-700" /></span>
                        <div><div className="font-semibold text-slate-900 text-sm">{tp.title}</div><div className="text-slate-500 text-[13px] leading-snug mt-0.5">{tp.desc}</div></div>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="bg-teal-700 rounded-2xl p-6 text-white">
                <h2 className="font-head font-bold text-lg mb-2">{t.contact.badge}</h2>
                <p className="text-teal-100 text-sm mb-4">{t.contact.subtitle}</p>
                <a href={contactInfo.phoneHref} className="inline-flex items-center gap-2 bg-white text-teal-700 font-semibold px-5 py-3 rounded-xl hover:bg-teal-50 transition-colors"><Phone className="w-4 h-4" /> {contactInfo.phone}</a>
              </div>
            </aside>
          </div>
        </div>
      </section>
      <WhyUs bg="cream" />
    </div>
  );
};

export default Booking;
